/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostinghelp1Inputs */

const en_crosspostinghelp1 = /** @type {(inputs: Crosspostinghelp1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Help`)
};

const de_crosspostinghelp1 = /** @type {(inputs: Crosspostinghelp1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hilfe`)
};

/**
* | output |
* | --- |
* | "Help" |
*
* @param {Crosspostinghelp1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostinghelp1 = /** @type {((inputs?: Crosspostinghelp1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostinghelp1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostinghelp1(inputs)
	return de_crosspostinghelp1(inputs)
});
export { crosspostinghelp1 as "crosspostingHelp" }